module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dinerMargin":"Margin by diner"},"es":{"dinerMargin":"Margen por comensal"}}')
  delete Component.options._Ctor
}
